import React from "react";

const LaptopImage = (props: React.SVGProps<SVGSVGElement>) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200">
            <g id="Layer_3" data-name="Layer 3">
                <path style={{ fill: '#3c4244'}} d="M90.38,148.72H47.28v-62a5.14,5.14,0,0,1,5.13-5.13h7.37a1,1,0,0,1,0,2H52.41a3.14,3.14,0,0,0-3.13,3.13v60h41.1a1,1,0,0,1,0,2Z"/>
                <path style={{ fill: '#3c4244'}} d="M152.72,148.72H109.23a1,1,0,0,1,0-2h41.49v-60a3.14,3.14,0,0,0-3.13-3.13H140a1,1,0,0,1,0-2h7.55a5.14,5.14,0,0,1,5.13,5.13Z"/>
                <path style={{ fill: '#689eb9'}} d="M147.58,156H52.42a8.28,8.28,0,0,1-8.28-8.28H92.78l.08.42A2.23,2.23,0,0,0,95.06,150h9.69a2.23,2.23,0,0,0,2.15-1.64l.16-.59h48.79A8.28,8.28,0,0,1,147.58,156Z"/>
                <path style={{ fill: '#3c4244'}} d="M147.58,157H52.42a9.29,9.29,0,0,1-9.27-9.28v-1H93.61l.24,1.23a1.24,1.24,0,0,0,1.21,1h9.69a1.24,1.24,0,0,0,1.19-.91l.36-1.33h50.55v1A9.29,9.29,0,0,1,147.58,157ZM45.21,148.72A7.29,7.29,0,0,0,52.42,155h95.17a7.29,7.29,0,0,0,7.21-6.28h-47a3.24,3.24,0,0,1-3.08,2.23H95.06A3.24,3.24,0,0,1,92,148.72Z"/>
                <path style={{ fill: '#3c4244'}} d="M148.48,144.86h-97V87h9.75a1,1,0,0,1,0,2H53.52v53.86h93V89h-5.7a1,1,0,0,1,0-2h7.7Z"/>
            </g>
        </svg>
    )
}

export default LaptopImage;